var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVuesaxBoldInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.983,
    height: 35,
    viewBox: "0 0 34.983 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_instagram",
    "data-name": "vuesax/bold/instagram",
    transform: "translate(-299.993 -443.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(299.993 443.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.833,0H10.168C3.8,0,0,3.8,0,10.168V24.815C0,31.2,3.8,35,10.168,35H24.815c6.37,0,10.168-3.8,10.168-10.168V10.168C35,3.8,31.2,0,24.833,0ZM17.5,24.29a6.79,6.79,0,1,1,6.79-6.79A6.8,6.8,0,0,1,17.5,24.29ZM27.86,8.54a2.021,2.021,0,0,1-.368.578,2.021,2.021,0,0,1-.578.368,1.732,1.732,0,0,1-1.908-.368,2.021,2.021,0,0,1-.368-.578,1.649,1.649,0,0,1,0-1.33,1.807,1.807,0,0,1,.368-.578,1.747,1.747,0,0,1,1.575-.473,1.056,1.056,0,0,1,.333.105,1.325,1.325,0,0,1,.315.158,2.757,2.757,0,0,1,.263.21,1.807,1.807,0,0,1,.368.578,1.649,1.649,0,0,1,0,1.33Z",
    transform: "translate(0 0)",
    fill: "#858689"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H34.969V34.969H0Z",
    transform: "translate(34.983 34.985) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldInstagram);
export default __webpack_public_path__ + "static/media/vuesax-bold-instagram.eac11fae047153ea729ed1e9b2db205b.svg";
export { ForwardRef as ReactComponent };